import TrendChart from 'src/javascripts/components/charts/TrendChart';

// Build trend line chart if present
export default function(settings) {
  let tableTrendChart = $('#tableTrendChart');
  let hasTrend = tableTrendChart.length !== 0;
  let c3NotLoadedTrend = typeof $('#tableTrendChart').data('c3-chart') === 'undefined';

  if ((hasTrend) && (c3NotLoadedTrend)) {
    let tableData = {};
    tableData['data'] = [['date'],['Data']];
    $.each(settings.json.data, function(i,d) {
      let num = Math.round(parseFloat(d.data_trend));
      tableData['data'][0].push(d.date_trend);
      tableData['data'][1].push(num)
    });
    let $chart = new TrendChart(tableTrendChart);
    $chart.render(tableData);
  }

}
